import styled, { css } from 'styled-components'

import { BreadcrumbItemProps } from './types'

export const BreadcrumbList = styled.ol`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  text-align: left;
`

export const BreadcrumbItem = styled.li<BreadcrumbItemProps>`
  ${({ theme, textColor }) => css`
    color: ${textColor || theme.colors.white};
    float: left;
    list-style-type: '>';
    margin-right: ${theme.spaces[2]}px;
    padding: 0 ${theme.spaces[2]}px 0 ${theme.spaces[2]}px;

    ${theme.below.mobileL`
      width: min-content;

      &:last-child {
        width: fit-content;
      }
    `}

    &:first-child {
      list-style-type: '';

      ${theme.above.laptop`
        padding: 0;
      `}
    }

    a {
      color: ${textColor || theme.colors.white};
      font-size: ${theme.spaces[3]}px;
      font-weight: ${theme.fontWeight[2]};
      text-decoration: none;
    }
  `}
`
